<template>
    <div class="ma-auto pa-3" style="min-width: 600px">
        {{ message }}
    </div>
</template>

<script>
export default {
    data() {
        return {
            message: 'Password reset is in progress.',
        };
    },
    created() {
        this.$api.resetPassword(this.$route.query.t, (data, meta) => {
            if (meta.code !== 200) {
                this.message = 'We were unable to reset your password. Please resend the reset password email and try again.';
                return;
            }
            const next = data.trim();
            this.$router.push({ name: 'account', query: { next } });
        });
    },
};
</script>

<style scoped></style>
